import { Routes } from '@angular/router';
import { ResumeComponent } from './resume/resume.component';
import { CategoriesComponent } from './categories/categories.component';
import { CategoryComponent } from './category/category.component';
import { ProductComponent } from './product/product.component';
import { productExistsGuardFn } from './product/product-exists.guard';
import { SearchResultsComponent } from './search-results/search-results.component';
import { ProductsByTagComponent } from './product-tags/products-by-tag/products-by-tag.component';
import { categoryExistsGuardFn } from './category/category-exists.guard';
import { singleCategoryRedirectGuardFn } from './categories/single-category-redirect.guard';
import { categoryResolverFn } from './category/category.resolver';
import { productResolverFn } from './product/product.resolver';
import { cartItemExistsGuardFn } from './product/cart-item-exists.guard';
import { cartItemResolverFn } from './product/cart-item.resolver';
import { productTagExistsGuardFn } from './product-tags/products-by-tag/product-tag-exists.guard';
import { productsTagResolverFn } from './product-tags/products-by-tag/product-tag.resolver';
import { repeatOrderGuardFn } from './repeat-order/repeat-order.guard';
import { cartDraftGuardFn } from './cart-draft/cart-draft.guard';

const establishmentRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: CategoriesComponent,
        canActivate: [singleCategoryRedirectGuardFn],
      },
      {
        path: 'categoria/:categoryId',
        component: CategoryComponent,
        canActivate: [categoryExistsGuardFn],
        resolve: {
          category: categoryResolverFn,
        },
      },
      // NOTE: deprecated route, the guard will redirect to /categoria/:categoryId/producto/:productId
      {
        path: 'producto/:productId',
        canActivate: [productExistsGuardFn],
        children: [],
      },
      {
        path: 'categoria/:categoryId/producto/:productId',
        component: ProductComponent,
        canActivate: [categoryExistsGuardFn, productExistsGuardFn],
        resolve: {
          category: categoryResolverFn,
          product: productResolverFn,
        },
      },
      {
        path: 'busqueda',
        component: SearchResultsComponent,
      },
      {
        path: 'productos-relacionados',
        component: ProductsByTagComponent,
        canActivate: [productTagExistsGuardFn],
        resolve: {
          productTag: productsTagResolverFn,
        },
      },
      {
        path: 'resumen',
        component: ResumeComponent,
      },
      {
        path: 'repetir/:orderId',
        canActivate: [repeatOrderGuardFn],
        children: [],
      },
      {
        path: 'armado/:draftId',
        canActivate: [cartDraftGuardFn],
        children: [],
      },
      {
        path: 'resumen/edicion/:cartItemId',
        component: ProductComponent,
        canActivate: [cartItemExistsGuardFn],
        resolve: {
          cartItem: cartItemResolverFn,
        },
      },

      {
        path: '**',
        // NOTE: this uses a functional redirect on purpose to prevent static rendering during SSR
        redirectTo: () => {
          return '';
        },
      },
    ],
  },
];

export default establishmentRoutes;
